import React from "react";
import "./BookList.css";

const books = [
  {
    id: 1,
    Title: "I love to the moon and back",
    author: "Amelia Hepworth, Tim Warnes",
    img:
      "https://images-na.ssl-images-amazon.com/images/I/513HOtc0W5L._AC_SX184_.jpg",
    Alt: "this image of the book",
  },

  {
    id: 2,
    Title: "The Hero Code: Lessons",
    author: "Amelia Hepworth, Tim Warnes",
    img:
      "https://images-na.ssl-images-amazon.com/images/I/41APkS19ZCL._AC_SX184_.jpg",
    Alt: "this image of the book",
  },

  {
    id: 3,
    Title: "The Hero Code: Lessons",
    author: "Amelia Hepworth, Tim Warnes",
    img:
      "https://images-na.ssl-images-amazon.com/images/I/416ztNCSb8L._AC_SX184_.jpg",
    Alt: "this image of the book",
  },

  {
    id: 4,
    Title: "The Hero Code: Lessons",
    author: "Amelia Hepworth, Tim Warnes",
    img:
      "https://images-na.ssl-images-amazon.com/images/I/41YoS8zTmQL._AC_SX184_.jpg",
    Alt: "this image of the book",
  },
];

function BookList() {
  return (
    <section className="booklist">
      {books.map((book) => {
        return <Book key={books.id} {...book}></Book>;
      })}
    </section>
  );
}

const Book = (props) => {
  const { img, Alt, Title, author } = props;
  return (
    <article className="book">
      <img src={img} alt={Alt} />
      <h3>{Title}</h3>
      <p>{author}</p>
    </article>
  );
};

export default BookList;
